import SolutionLayout, {
  type SolutionData,
} from "../../components/SolutionLayout";
import {
  RouteIcon,
  LayersIcon,
  BookIcon,
} from "../../components/Icons";

const data: SolutionData = {
  path: "/solutions/marketplaces",
  eyebrow: "Solution · Marketplaces",
  headline: "Buyers and sellers in one inbox, answered consistently.",
  lede: "A marketplace hears from both sides, and both expect fair, consistent answers. ZopDesk keeps them apart with queues and rules, keeps your policy wording in saved replies, and keeps the reasoning in internal notes.",
  stats: [
    { value: "Queues", label: "One per support address", sub: "e.g. buyers@ and sellers@" },
    { value: "Rules", label: "Assign and tag on arrival", sub: "By queue, sender, subject or message" },
    { value: "Notes", label: "Internal, on the ticket", sub: "Never sent to the customer" },
  ],
  painFix: [
    {
      pain: "Buyer complaints and seller questions land in the same inbox, and the right people don't see the right tickets.",
      fix: "Forward buyers@ and sellers@ (or any addresses you like) to ZopDesk. Each address is a queue, and rules on the queue tag and assign tickets to the right team.",
    },
    {
      pain: "Refund and return decisions vary from agent to agent, and customers learn to ask twice.",
      fix: "Keep your policy wording in saved replies so every agent starts from the same answer.",
    },
    {
      pain: "When a decision is questioned later, nobody remembers why it was made.",
      fix: "Agents record the reasoning, and any photos or documents, as internal notes and attachments on the ticket, next to the conversation.",
    },
  ],
  highlights: [
    {
      Icon: RouteIcon,
      title: "Queues and rules",
      body: "Rules match on queue, sender, subject or message text and assign, round-robin, tag or set priority.",
    },
    {
      Icon: BookIcon,
      title: "Policy saved replies",
      body: "Refund, return and dispute answers written once, with the customer's name and ticket subject filled in.",
    },
    {
      Icon: LayersIcon,
      title: "Internal notes and attachments",
      body: "Notes and files up to 10 MB on the ticket timeline, visible to your team only.",
    },
  ],
  relatedSolutions: [
    { to: "/solutions/dtc", label: "Direct-to-consumer" },
    { to: "/solutions/b2b", label: "B2B & wholesale" },
    { to: "/solutions/subscription", label: "Subscription" },
  ],
};

export default function SolutionMarketplaces() {
  return <SolutionLayout data={data} />;
}
